import { hot } from 'react-hot-loader/root';
import React from 'react';
import { MujiRouter, Router } from '@souche-f2e/muji';


const routes = [
  {
    "path": "/",
    "children": [
      {
        "path": "",
        "component": require('../pages/index.jsx').default
      },
      {
        "path": "Home",
        "children": [
          {
            "path": "",
            "component": require('../pages/Home/index.jsx').default
          }
        ]
      },
      {
        "path": "dashboard",
        "children": [
          {
            "path": "",
            "component": require('../pages/dashboard/index.jsx').default
          },
          {
            "path": "app",
            "children": [
              {
                "path": ":key",
                "children": [
                  {
                    "path": "",
                    "component": require('../pages/dashboard/app/$key/index.jsx').default
                  }
                ]
              }
            ]
          },
          {
            "path": "info",
            "children": [
              {
                "path": "",
                "component": require('../pages/dashboard/info/index.jsx').default
              }
            ]
          },
          {
            "path": "stable",
            "children": [
              {
                "path": "",
                "component": require('../pages/dashboard/stable/index.jsx').default
              }
            ]
          },
          {
            "path": "traffic_stat",
            "children": [
              {
                "path": "",
                "component": require('../pages/dashboard/traffic_stat/index.jsx').default
              }
            ]
          }
        ]
      },
      {
        "path": "documents",
        "children": [
          {
            "path": "",
            "component": require('../pages/documents/index.jsx').default
          },
          {
            "path": "common_tools",
            "children": [
              {
                "path": "",
                "component": require('../pages/documents/common_tools/index.jsx').default
              }
            ]
          },
          {
            "path": "docking_process",
            "children": [
              {
                "path": "",
                "component": require('../pages/documents/docking_process/index.jsx').default
              }
            ]
          },
          {
            "path": "docs",
            "children": [
              {
                "path": "",
                "component": require('../pages/documents/docs/index.jsx').default
              },
              {
                "path": "api",
                "children": [
                  {
                    "path": "",
                    "component": require('../pages/documents/docs/api/index.jsx').default
                  },
                  {
                    "path": ":docs",
                    "children": [
                      {
                        "path": "",
                        "component": require('../pages/documents/docs/api/$docs/index.jsx').default
                      }
                    ]
                  }
                ]
              },
              {
                "path": "group",
                "children": [
                  {
                    "path": "",
                    "component": require('../pages/documents/docs/group/index.jsx').default
                  },
                  {
                    "path": ":id",
                    "children": [
                      {
                        "path": "",
                        "component": require('../pages/documents/docs/group/$id/index.jsx').default
                      }
                    ]
                  }
                ]
              }
            ],
            "component": require('../pages/documents/docs/_layout/index.jsx').default
          },
          {
            "path": "izayoi_message",
            "children": [
              {
                "path": "message",
                "children": [
                  {
                    "path": "",
                    "component": require('../pages/documents/izayoi_message/message/index.jsx').default
                  }
                ]
              }
            ],
            "component": require('../pages/documents/izayoi_message/_layout/index.jsx').default
          },
          {
            "path": "mobile_process",
            "children": [
              {
                "path": "",
                "component": require('../pages/documents/mobile_process/index.jsx').default
              }
            ]
          },
          {
            "path": "other_docs",
            "children": [
              {
                "path": "common",
                "children": [
                  {
                    "path": "docs",
                    "children": [
                      {
                        "path": "",
                        "component": require('../pages/documents/other_docs/common/docs/index.jsx').default
                      }
                    ]
                  },
                  {
                    "path": "introduce",
                    "children": [
                      {
                        "path": "",
                        "component": require('../pages/documents/other_docs/common/introduce/index.jsx').default
                      }
                    ]
                  },
                  {
                    "path": "usage",
                    "children": [
                      {
                        "path": "",
                        "component": require('../pages/documents/other_docs/common/usage/index.jsx').default
                      }
                    ]
                  }
                ]
              }
            ],
            "component": require('../pages/documents/other_docs/_layout/index.jsx').default
          },
          {
            "path": "security_guard",
            "children": [
              {
                "path": "",
                "component": require('../pages/documents/security_guard/index.jsx').default
              }
            ]
          },
          {
            "path": "stable_docs",
            "children": [
              {
                "path": "",
                "component": require('../pages/documents/stable_docs/index.jsx').default
              },
              {
                "path": "api",
                "children": [
                  {
                    "path": "",
                    "component": require('../pages/documents/stable_docs/api/index.jsx').default
                  },
                  {
                    "path": ":docs",
                    "children": [
                      {
                        "path": "",
                        "component": require('../pages/documents/stable_docs/api/$docs/index.jsx').default
                      }
                    ]
                  }
                ]
              },
              {
                "path": "group",
                "children": [
                  {
                    "path": "",
                    "component": require('../pages/documents/stable_docs/group/index.jsx').default
                  },
                  {
                    "path": ":id",
                    "children": [
                      {
                        "path": "",
                        "component": require('../pages/documents/stable_docs/group/$id/index.jsx').default
                      }
                    ]
                  }
                ]
              }
            ],
            "component": require('../pages/documents/stable_docs/_layout/index.jsx').default
          }
        ]
      },
      {
        "path": "notices",
        "children": [
          {
            "path": "",
            "component": require('../pages/notices/index.jsx').default
          }
        ]
      },
      {
        "path": "signIn",
        "children": [
          {
            "path": "",
            "component": require('../pages/signIn/index.jsx').default
          }
        ]
      },
      {
        "path": "solve_center",
        "children": [
          {
            "path": "",
            "component": require('../pages/solve_center/index.jsx').default
          }
        ]
      },
      {
        "path": "support",
        "children": [
          {
            "path": "FAQ",
            "children": [
              {
                "path": "",
                "component": require('../pages/support/FAQ/index.jsx').default
              }
            ]
          },
          {
            "path": "work_order",
            "children": [
              {
                "path": "",
                "component": require('../pages/support/work_order/index.jsx').default
              }
            ]
          }
        ]
      }
    ],
    "component": require('../pages/_layout/index.jsx').default
  }
];

routes.push(
  {
    "path": "*",
    "component": require('../pages/404').default,
  }
);

const routerOptions = {
  routes,
  
};

export const router = new Router(routerOptions);

const Root = () => (
  <MujiRouter router={router} />
);

export default hot(Root);
